import {Kind, Direction, Injector} from './types';

function createInjector(direction: Direction): Injector {
  return function injectSafe(type: Kind): string {
    return `
      ${type}-${direction}: constant(safe-area-inset-${direction});
      ${type}-${direction}: env(safe-area-inset-${direction});
    `;
  };
}

export const injectSafeTop = createInjector('top');
export const injectSafeBottom = createInjector('bottom');

export const injectSafeLeft = createInjector('left');
export const injectSafeRight = createInjector('right');
